import React, { Component } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import CoreService from "../../../../services/CoreService";

import BoolCellTrueOnlyRenderer from "../../../../components/lib/agGridRenderers/BoolCellTrueOnlyRenderer";


/*
const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";
*/


export default class SummaryBatchGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gridData: ''
        };
        this.CoreService = new CoreService();
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onRowDoubleClicked = this.onRowDoubleClicked.bind(this);
        this.refreshGrid = this.refreshGrid.bind(this);

        this.columnDefs = [
            { headerName: "PO", field: "retailerBatchId", sortable: true, filter: true, resizable: true, maxWidth: 130},
            { headerName: "Order", field: "customerBatchId", sortable: true, filter: true, resizable: true, maxWidth: 120},
            { headerName: "Posted", field: "eventDateTimeLocal", sortable: true, filter: true, resizable: true},
            { headerName: "Repost?", field: "repostInfo.isRepost", sortable: true, filter: true, resizable: true, maxWidth: 110, cellRendererFramework: BoolCellTrueOnlyRenderer},
            { headerName: "Status", field: "status", sortable: true, filter: true, resizable: true, maxWidth: 100}, 
            { headerName: "Shipped", field: "shipDateTimeLocal", sortable: true, filter: true, resizable: true, maxWidth: 120},
            { headerName: "Eta", field: "etaDateTimeLocal", sortable: true, filter: true, resizable: true, maxWidth: 120},           
            { headerName: "Last Message", field: "lastMessage", sortable: true, filter: true, resizable: true, minWidth: 100, wrapText: true, autoHeight: true },
            { headerName: "Batch Id", field: "batchId", sortable: true, filter: true, resizable: true}
        ];

    }


    async componentDidMount() 
    {
        await this.refreshGrid()
    }

    async componentDidUpdate(prevProps, prevState)
    {
        if ((prevProps.searchKey !== this.props.searchKey) || (prevProps.autoRefreshTriggerKey !== this.props.autoRefreshTriggerKey))
        {
            await this.refreshGrid();
        }
    }

    async refreshGrid() 
    {
        if (!this.props.searchParams) return;
        this.props.setLoading(true);
        try
        {
            var batchSummaryResult = await this.CoreService.fetchSummaryBatchList(this.props.searchParams, this.props.userSession.gcid, this.props.userSession.token)
            // TBD - deal with error
            this.setState({gridData: batchSummaryResult.dataResult})
        }
        finally
        {
            this.props.setLoading(false);
        }
    }



    onSelectionChanged() {
        console.log("Changing selected row")
        var selectedNodes = this.gridApi.getSelectedNodes();
        var rowData = selectedNodes[0].data;
        // var rowNode = selectedNodes[0];
        console.info(rowData);
        this.props.onRowSelected(rowData); 
    }

    onRowDoubleClicked(row) {
        console.group("On Row Double Clicked Row: ");
        console.log(row);
        console.groupEnd();
        // var rowData = row.data;
        // this.props.onRowSelected(row);
        this.props.onRowDetailModalToggle();
        //this.props.onEditRequest();
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit(params)
    };

    render() {
        const divStyle = {
            width: "100%",
            height:"35vh"
            //border: '5px solid black'
        };

        const gridOptions = {
            onRowDoubleClicked: this.onRowDoubleClicked
        }

        /*
        if (this.dataReady){
          console.log(" Lines (this.props.rowData) about to be rendered: ");
          console.log(this.props.rowData);
          this.gridApi.setRowData(this.props.rowData);
        }
        */

        // const gridData = (this.props.rowData) ? this.props.rowData : [{}];
        const gridData = this.state.gridData

        return (
            <div className="ag-theme-balham" style={divStyle}>
                <AgGridReact
                    rowSelection="single"
                    enableRangeSelection={false}
                    pagination={true}
                    paginationPageSize={10}
                    columnDefs={this.columnDefs}
                    rowData={gridData}
                    animateRows={true}
                    onGridReady={this.onGridReady}
                    // onSelectionChanged={this.onSelectionChanged.bind(this)}
                    onSelectionChanged={this.onSelectionChanged}
                    gridOptions={gridOptions}
                    onRowDoubleClicked={(e) => this.onRowDoubleClicked()}
                />
            </div>
        );
    }
}